"use strict";

/**
 * Desktop banner inside video when it's paused
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  // to prevent double loading/execution in SPA mode
  var loaded = false;

  /**
   * Do stuff on the page load
   */
  function onPageLoad() {
    if (loaded) {
      // to prevent double loading/execution in SPA mode
      return;
    }
    loaded = true;

    // Hide Ads on close overlay and continue video playing
    document.addEventListener('click', function (e) {
      if (e.target.closest('.pause-overlay')) {
        FlixVideo.playVideo();
      }
    });
    document.addEventListener('flix:video:ready', function (e) {
      return onPlayerReady(e.detail.player);
    });
  }

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    /** Desktop only */ && FlixUtils.isDesktop()
    /** Only on video page */ && document.querySelector('#in_video_ad');
  }
  ;

  /**
   * Main logic
   * @param {Object} player Plyr instance
   */
  function onPlayerReady(player) {
    if (!isEnabled()) {
      return;
    }
    player.on('pause', function () {
      document.querySelector('.pause-overlay').classList.remove('d-none');
    });
    player.on('play seeking', function () {
      document.querySelector('.pause-overlay').classList.add('d-none');
    });
    var el = document.querySelector('#in_video_ad');
    if (Flix.isTna()) {
      el.innerHTML = "<ins class=\"adsbyexoclick\" data-zoneid=\"4505232\" data-keywords=\"".concat(Flix.ads.tags, "\" data-sub=\"").concat(Flix.ads.iid, "\"></ins>");
      var s = document.createElement('script');
      s.onload = function () {
        return (AdProvider = window.AdProvider || []).push({
          "serve": {}
        });
      };
      s.src = 'https://a.realsrv.com/ad-provider.js';
      el.appendChild(s);
    } else {
      el.innerHTML = "<iframe class=\"na\" frameborder=\"0\" scrolling=\"no\" width=\"300\" height=\"250\" sandbox=\"allow-scripts allow-popups allow-forms allow-same-origin\" \n            src=\"//a.shukriya90.com/api/spots/350564?p=1&s1=".concat(Flix.ads.iid, "&kw=").concat(Flix.ads.tags, "\"></iframe>");
    }
  }
  ;
})();